import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String }

  share(event) {
    event.preventDefault()
    
    if (navigator.share) {
      // Use native share API if available (mobile devices)
      navigator.share({
        title: this.titleValue,
        url: this.urlValue
      }).then(() => {
        console.log('✅ Content shared successfully')
        this.showFeedback('Shared!')
      }).catch(err => {
        console.log('❌ Error sharing:', err)
        this.fallbackShare()
      })
    } else {
      // Fallback to clipboard copy
      this.fallbackShare()
    }
  }

  fallbackShare() {
    // Copy URL to clipboard
    navigator.clipboard.writeText(this.urlValue).then(() => {
      console.log('✅ URL copied to clipboard')
      this.showFeedback('Link copied!')
    }).catch(err => {
      console.log('❌ Failed to copy URL:', err)
      this.showFeedback('Share failed')
    })
  }

  showFeedback(message) {
    const button = this.element
    const originalContent = button.innerHTML
    
    // Show success message
    button.innerHTML = `<i class="fas fa-check mr-1"></i>${message}`
    button.classList.add('text-green-500')
    
    // Revert after 2 seconds
    setTimeout(() => {
      button.innerHTML = originalContent
      button.classList.remove('text-green-500')
    }, 2000)
  }
}